<template>
    <el-dialog :visible.sync="showPopup"
               :append-to-body="true"
               width="600px"
               title="显示字段设置">
        <div>
            <el-checkbox-group v-model="selected_columns">
                <el-checkbox v-for="(item,idx) in table_columns"
                             :key="idx"
                             :label="item.name">{{item.label}}</el-checkbox>
            </el-checkbox-group>
        </div>
        <div slot="footer">
            <el-button type="default"
                       size="small"
                       @click="onClose">取消</el-button>
            <el-button type="primary"
                       size="small"
                       @click="onSaveSetting">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { getStorageItem, setStorageItem, hasStorageItem } from '@/api/api'
export default {
    props: {
        cacheKey: String
    },
    data () {
        return {
            showPopup: false,
            table_columns: [],
            selected_columns: []
        }
    },
    methods: {
        show (table_columns, selected_columns) {
            this.table_columns = table_columns
            this.selected_columns = selected_columns
            this.showPopup = true
        },
        onClose () {
            this.showPopup = false
        },
        onSaveSetting () {
            this.showPopup = false
            setStorageItem(this.cacheKey, this.selected_columns)
            this.$emit('save', this.selected_columns)
        },
    }
}
</script>
